/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { NavLink, Route, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from 'semantic-ui-react';
import Menu, { SubMenu, Item as MenuItem } from 'rc-menu';
import routes from '../../routes/sidebar';
import Logo from '../../assets/images/logo.svg';
import LogoDark from '../../assets/images/logo-dark.svg';
import * as Icons from '../../assets/icons';
import 'rc-menu/assets/index.css';
import styles from './Sidebar.module.scss';
import Paths from '../../constants/Paths';

const SidebarContent = React.memo(({ isAdmin, isManager, path, toggleMenu, onUsers }) => {
  const [t] = useTranslation();

  const Icon = ({ icon, ...props }) => {
    const IconItem = Icons[icon];
    return <IconItem {...props} />;
  };

  const setTitleSubMenu = (route) => {
    return (
      <>
        <Icon className="" aria-hidden="true" icon={route.icon} />
        <span className="menu_item">{t(route.name)}</span>
      </>
    );
  };

  const renderMenuItem = (routeItem) => {
    return (
      <MenuItem key={routeItem.key}>
        <NavLink to={routeItem.path} exact className="active">
          <Route path={routeItem.path} exact={routeItem.exact}>
            <span className={styles.menu_active} aria-hidden="true" />
          </Route>
          <span className={styles.menu_item_inner}>
            <Icon icon={routeItem.icon} />
            <span className={styles.menu_text}>{t(routeItem.name)}</span>
          </span>
        </NavLink>
      </MenuItem>
    );
  };

  const renderSubItem = (routeItem) => {
    if (routeItem.isAdmin === true) {
      if (isAdmin) {
        if (routeItem.key === 'users') {
          return (
            <MenuItem key={routeItem.key} onClick={onUsers}>
              <div className="menu_item_link">
                <span className={styles.menu_item_inner}>
                  <Icon icon={routeItem.icon} />
                  <span className={styles.menu_text}>{t(routeItem.name)}</span>
                </span>
              </div>
            </MenuItem>
          );
        }
        return renderMenuItem(routeItem);
      }
    }
    if (routeItem.isManager === true) {
      if (isManager) {
        if (routeItem.key === 'users') {
          return (
            <MenuItem key={routeItem.key} onClick={onUsers}>
              <div className="menu_item_link">
                <span className={styles.menu_item_inner}>
                  <Icon icon={routeItem.icon} />
                  <span className={styles.menu_text}>{t(routeItem.name)}</span>
                </span>
              </div>
            </MenuItem>
          );
        }
        return renderMenuItem(routeItem);
      }
    } else {
      return renderMenuItem(routeItem);
    }
    return '';
  };

  const renderSubMenuItem = (route) => {
    if (route.key === 'setting' && !isAdmin && !isManager) {
      return '';
    }
    if (route.key === 'deviceSetting' && !isAdmin && !isManager) {
      return '';
    }

    return (
      <SubMenu title={setTitleSubMenu(route)} key={route.key} mode="inline">
        {route.routes.map((r) => renderSubItem(r))}
      </SubMenu>
    );
  };

  let currentPath = [];
  routes.forEach((route) => {
    if (route.path === path) {
      currentPath = [route.key];
    }
    if (route.routes) {
      route.routes.forEach((r) => {
        if (r.path === path) {
          currentPath = [r.key, route.key];
        }
      });
    }
  });
  return (
    <div className={`${styles.wrapper_content}`}>
      <div className={styles.menu_header}>
        <Link to={Paths.DASHBOARD} className={styles.logo}>
          <div className={styles.logo_white}>
            <img src={Logo} alt="Logo" />
          </div>
          <div className={styles.logo_dark}>
            <img src={LogoDark} alt="Logo" />
          </div>
        </Link>
        <Button className={styles.button_toggle_menu} onClick={toggleMenu}>
          <Icon icon="MenuIcon" />
        </Button>
      </div>
      <Menu
        className={styles.menuWrapper}
        mode="inline"
        defaultSelectedKeys={currentPath}
        defaultOpenKeys={currentPath}
      >
        {routes.map((route) => (route.routes ? renderSubMenuItem(route) : renderMenuItem(route)))}
      </Menu>
      <div className={styles.buttonWrapper}>
        {/* <Button className={styles.button_support}>
          <Icon icon="PhoneIcon" />
          <span>{t('sidebar.buttonSupport')}</span>
        </Button> */}
        <div className={styles.copyright}>{t('common.copyright')}</div>
      </div>
    </div>
  );
});

SidebarContent.propTypes = {
  isAdmin: PropTypes.bool.isRequired,
  isManager: PropTypes.bool.isRequired,
  path: PropTypes.string.isRequired,
  toggleMenu: PropTypes.func.isRequired,
  onUsers: PropTypes.func.isRequired,
};

export default SidebarContent;
